<template>
    <div class="js-user-list-item-edit d-flex align-items-center justify-content-between" :style="user_suspend ? {opacity: .3} : ''">
        <user-thumbnail :thumbnail="thumbnail" :userStatusBgColor="userStatusBgColor"></user-thumbnail>
        <div class="user-list-item__details flex-fill">
            <strong class="user-list-item__title">{{ caption }} <span v-if="user_suspend"> (Beurlaubt)</span> <span v-if="!user_active"> (Nicht aktiv)</span></strong>
            <p v-if="contact_email" v-html="contact_email"></p>
            <p v-if="contact_mobile" v-html="contact_mobile"></p>
            <small class="d-block" v-if="hide_activity_buttons">{{ attendee.status }}</small>
        </div>
        <template v-if="!hide_activity_buttons">
            <div class="user-list-item__edit bg-dark text-white" :class="status_nr == 0 ? 'disabled' : ''" v-if="isActivity" @click="setStatus(attendee, 0, $event)">
                <font-awesome-icon fixed-width :icon="['far', 'question-circle']" />
            </div>
            <div class="user-list-item__edit bg-danger text-white" :class="status_nr == 2 ? 'disabled' : ''" v-if="isActivity" @click="setStatus(attendee, 2, $event)">
                <font-awesome-icon fixed-width :icon="['far', 'minus-circle']" />
            </div>
            <div class="user-list-item__edit bg-success text-white" :class="status_nr == 1 ? 'disabled' : ''" v-if="isActivity" @click="setStatus(attendee, 1, $event)">
                <font-awesome-icon fixed-width :icon="['far', 'plus-circle']" />
            </div>
        </template>

        <router-link :to="{ name: 'user-edit', params: { Id: attendee.user_id }}" class="user-list-item__edit bg-primary text-white" v-if="isMemberAdmin && hide_activity_buttons" @click="editMember(attendee.user_id)">
            <font-awesome-icon fixed-width :icon="['far', 'user-edit']" style="margin-left: 2px;" />
        </router-link>
    </div>
</template>

<script>
import { mapGetters, mapActions} from "vuex";
// import UserStatusIconVue from './UserStatusIcon.vue'
import UserThumbnailVue from './UserThumbnail.vue';
export default {
    name: 'user-list-item-edit',
    components: {
        // 'user-status-icon': UserStatusIconVue,
        'user-thumbnail': UserThumbnailVue
    },
    props: {
        caption: {
            type: String
        },
        sub_caption: {
            type: String,
            default: ''
        },
        attendee: {
            type: Object
        },
        agenda_hash: {
            type: String
        },
        hide_activity_buttons: {
            type: Boolean,
            default: false
        },
        thumbnail: {
            type: String,
            default: ''
        },
        user_active: {
            type: Boolean,
            default: true
        },
        user_suspend: {
            type: Boolean,
            default: false
        },
        contact_mobile: {
            type: String,
            default: ''
        },
        contact_email: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            status_nr: -1
        }
    },
    mounted() {
        this.status_nr = parseInt(this.attendee.status);
    },
    computed:{
        ...mapGetters('auth', ['isActivity', 'isMemberAdmin']),
        ...mapGetters('events', ['fetching', 'event']),
        userStatusBgColor() {
            let bgColor = 'primary';
            switch (this.status_nr) {
                case 0:
                    bgColor = 'primary';
                    break;
                case 1:
                    bgColor = 'success';
                    break;
                case 2:
                    bgColor = 'danger';
            }

            if (this.$route.name == 'users') {
                if (this.user_suspend) {
                    bgColor = 'danger';
                }
            }

            return bgColor;
        }
    },
    methods: {
        ...mapActions('events', ['updateApplicationStatus']),
        setStatus(attendee, status_nr, e) {
            const btn = e.srcElement.tagName == 'svg' || e.srcElement.tagName == 'path' ? e.srcElement.closest('.user-list-item__edit') : e.srcElement;
            const neighboorBtns = btn.closest('.js-user-list-item-edit').querySelectorAll('.user-list-item__edit');

            neighboorBtns.forEach(btn => {
                btn.classList.remove('disabled');
            });
            btn.classList.add('disabled');
            this.status_nr = status_nr;

            this.updateApplicationStatus({event_id: this.event.ID, status_data: {
                agenda_hash: this.agenda_hash,
                attendee: attendee,
                status_nr: status_nr
            }});
        }
    }
}
</script>

<style lang="scss">
    .user-list-item__details {
        p {
            padding:0;
            margin: 5px 0;

            &:last-child {
                margin-bottom: 10px;
            }
        }
    }

    .user-list-item__edit {
        cursor: pointer;
    }

</style>